"use client";

import type { ComponentProps } from "react";
import { Toaster as Sonner } from "sonner";

import { baseToastOptions, mergeToastOptions, toastIcons } from "./toast";

type ToasterProps = ComponentProps<typeof Sonner>;

export default function Toaster({ toastOptions, icons, ...props }: ToasterProps) {
  return (
    <Sonner
      className="toaster group"
      icons={{ ...toastIcons, ...icons }}
      toastOptions={mergeToastOptions(baseToastOptions, toastOptions)}
      {...props}
    />
  );
}
